export const TNC_HALF_CARD_TITLE = "Offer Details";
export const TNC_HALF_CARD_CTA_TEXT = "Okay";
